import WorktypesGrid from "../../components/grids/WorktypesGrid";
import AddWorkTypeForm from "../../components/FormComps/Worktypes/AddWorkTypeForm";
import EditWorkTypeForm from "../../components/FormComps/Worktypes/EditWorkTypeForm";

import { useState, useEffect } from "react";
import { useToast } from "../../contexts/ToastContext";

import {
  Drawer,
  DrawerContent,
  DrawerNavigation,
} from "@progress/kendo-react-layout";
import { FaTimesCircle } from "react-icons/fa";
import {
  submitWorktype,
  getWorktypes,
  deleteWorktype,
} from "../../data/worktypeData";
import { worktypesGrid, postWorktypeTypes, InvoiceDescriptionGrid, dropDown } from "../../data/interfaces";

import "../Styles.css";
import InvoiceDescriptionsGrid from "../../components/grids/InvoiceDescriptionsGrid";
import { getInvoiceTemplateData } from "../../data/invoiceTemplateData";
import EditInvoiceDescriptionsForm, { DescriptionObject } from "../../components/FormComps/InvoiceDescriptions/EditInvoiceDescriptionsForm";
import { getInvoiceItemDescriptionData } from "../../data/invoiceItemDescription";
import { getInvoiceItemDescriptionDataById } from "../../data/invoiceItemDescriptionById";
import { canEditArea } from "../../helpers/areaAccess";

interface Description {
  templateId: number;
  name: string
}

interface InvoiceDescriptionsProps {
  allowedRoutes?: string[];
}

const InvoiceDescriptions = (props: InvoiceDescriptionsProps) => {
  // InvoiceDescriptions.Manage or an administrator (see areaAccess.ts). The server enforces the same.
  const canEdit = canEditArea(props.allowedRoutes, "InvoiceDescriptions");
  const [descriptions, setDescriptions] = useState<Description[]>([]);

  const fetchInvoiceTemplateOptions = async () => {
    const data = await getInvoiceTemplateData();
    const items = data.map(item => ({templateId: item.value, name: item.text}))
    setDescriptions(items);
  }

  useEffect(() => {
    fetchInvoiceTemplateOptions();
  },[]);

  // const [worktypeData, setWorktypeData] = useState<worktypesGrid[]>([]);
  const [expanded, setExpanded] = useState(false);
  const [editFormVisible, setEditFormVisible] = useState(false);
  const [addFormVisible, setAddFormVisible] = useState(false);
  const [selectedDescription, setSelectedDescription] = useState<Description | null>(null);
  const [selectedDescriptionText, setSelectedDescriptionText] = useState<DescriptionObject | undefined>(undefined);
  const { showToast } = useToast();


  // const handleAddForm = () => {
  //   setAddFormVisible((prevState) => (!prevState ? true : true));
  //   setEditFormVisible(false);
  //   handleExpanded();
  // };

  const handleEditForm = (item: Description) => {
    setSelectedDescription(item);
    setEditFormVisible((prevState) => (!prevState ? true : true));
    setAddFormVisible(false);
    handleExpanded();
  };

  const fetchInvoiceDescription = async () => {
    if(selectedDescription) {
      const description = await getInvoiceItemDescriptionDataById(selectedDescription.templateId.toString())
      setSelectedDescriptionText(description)
    }
  }

  useEffect(() => {
    fetchInvoiceDescription();
  }, [selectedDescription])

  // const updateWorktypeHandler = (dataItem: any, id: number) => {
  //    updateWorktype(dataItem, id)
  //       .then(() => {
  //          const fetchData = async () => {
  //             const worktypeData = await getWorktypes();
  //             setWorktypeData(worktypeData)
  //          }
  //          fetchData()
  //       })
  //    handleExpanded()
  //    showToast('Worktype succesfully updated', 'success');
  // };

  // const newWorktypeHandler = (dataItem: postWorktypeTypes) => {
  //   submitWorktype(dataItem).then(() => {
  //     const fetchData = async () => {
  //       const worktypeData = await getWorktypes();
  //       setWorktypeData(worktypeData);
  //     };
  //     fetchData();
  //   });
  //   handleExpanded();
  //   showToast("Worktype succesfully added", "success");
  // };

  // useEffect(() => {
  //   const fetchData = async () => {
  //     const worktypeData = await getWorktypes();
  //     setWorktypeData(worktypeData);
  //   };

  //   fetchData();
  // }, []);

  // const deleteWorktypeHandler = (id: number) => {
  //   deleteWorktype(id)
  //     .then(() => {
  //       setWorktypeData((prevData) =>
  //         prevData.filter((worktype) => worktype.worktypeId !== id)
  //       );
  //     })
  //     .catch((error) => {
  //       // Handle error, for example, showing a toast message about the failure
  //       showToast("Error deleting worktype", "error");
  //     });
  //   handleExpanded();
  //   showToast("Worktype succesfully deleted", "success");
  // };

  const handleExpanded = () => {
    setExpanded((prevState) => !prevState);

    if (editFormVisible) {
      setEditFormVisible(false);
      setSelectedDescriptionText(undefined)
    }
    if (addFormVisible) {
      setAddFormVisible(false);
    }
  };

  const handleSelect = () => {
    setExpanded(false);
  };

  return (
    <div>
      <Drawer
        expanded={expanded}
        position={"end"}
        width={750}
        mode="overlay"
        animation={{
          duration: 400,
        }}
        onOverlayClick={handleExpanded}
        onSelect={handleSelect}
      >
        <DrawerContent>
          <DrawerNavigation>
            {addFormVisible && (
              <>
                <div className="form__title__container">
                  <h1 className="form__title">Add Worktype</h1>
                  <FaTimesCircle
                    className="closeform"
                    onClick={handleExpanded}
                  />
                </div>
                <div className="form__wrapper">
                  {/* <AddWorkTypeForm onWorkTypeSubmit={newWorktypeHandler} /> */}
                  {/* <WorkTypeForm
                    onSuccess={handleExpanded}
                  /> */}
                </div>
              </>
            )}

            {editFormVisible && (
              <>
                <div className="form__title__container">
                  <h1 className="form__title">{canEdit ? "Edit Invoice Description" : "Invoice Description"}</h1>
                  <FaTimesCircle
                    className="closeform"
                    onClick={handleExpanded}
                  />
                </div>
                <EditInvoiceDescriptionsForm
                  // onEditSubmit={updateWorktypeHandler}
                  description={selectedDescriptionText}
                  handleExpanded={handleExpanded}
                  readOnly={!canEdit}
                  // onWorktypeDelete={deleteWorktypeHandler}
                />
                {/* <WorkTypeForm
                    onSuccess={handleExpanded}
                    onWorktypeId={worktypeId}
                  /> */}
              </>
            )}
          </DrawerNavigation>

          <InvoiceDescriptionsGrid
            // onAddToggle={handleAddForm}
            onEditToggle={handleEditForm}
            onData={descriptions}
          />
        </DrawerContent>
      </Drawer> 
    </div>
  );
};

export default InvoiceDescriptions;
